import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a59a0fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mt-3",
  "data-testid": "sheet-action-bar"
}
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-neutral50 mb-2",
  "data-testid": "sheet-advance-block-reason"
}
const _hoisted_3 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_4 = {
  key: 0,
  id: "sheet-shortcuts-popover",
  role: "group",
  "aria-label": "Lista de atalhos de teclado",
  class: "sheet-shortcuts-popover",
  "data-testid": "sheet-shortcuts-popover"
}

import { ref, watch, onBeforeUnmount } from 'vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { SHEET_SHORTCUTS } from '@/components/designSystem/Cards/sheet-keyboard'
import type { SheetModelOption } from '../utils/sheet-action-bar.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceSheetActionBar',
  props: {
    showRowControls: { type: Boolean },
    reason: {},
    canUndo: { type: Boolean },
    canAddRow: { type: Boolean },
    addRowReason: {},
    canDeleteRow: { type: Boolean },
    deleteRowReason: {},
    sheetModels: {},
    selectedSheetModel: {}
  },
  emits: ["undo", "addRow", "deleteRow", "selectSheetModel"],
  setup(__props: any, { emit }) {

const props = __props;

/**
 * RF-12/#2119 — barra de ações da folha de monitoração (engine `spreadsheet`, flag
 * ligada). Consolida os três elementos soltos que já existiam em
 * `DsAttendanceAwaitingAudit.vue` (motivo do bloqueio, "Desfazer", autocomplete de
 * modelo) e adiciona "Adicionar linha" (RF-12) — nenhum elemento de UI novo na
 * fronteira do teto (RN-11): tooltip e rodapé reusam o mesmo padrão do motivo do menu
 * de coluna (RF-06). O componente é agnóstico de domínio: quem decide `reason`,
 * `canAddRow` etc. é a tela chamadora.
 */




/**
 * RF-10/RN-11 (#2118) — popover "Atalhos": documenta a lista completa de `sheet-keyboard.ts`
 * (design system — este componente é `Modules`, pode importar de lá; a direção proibida é
 * a contrária). Fecha ao clicar fora, mesmo padrão do menu de coluna do
 * `AttendanceSheetCard`.
 */
const showShortcuts = ref(false)
const shortcutsContainerRef = ref<HTMLElement | null>(null)

function toggleShortcuts() {
  showShortcuts.value = !showShortcuts.value
}

function handleOutsideClick(event: MouseEvent) {
  if (shortcutsContainerRef.value?.contains(event.target as Node)) return
  showShortcuts.value = false
}

/** RNF Acessibilidade — Esc fecha o popover pelo teclado, sem depender de um mousedown fora. */
function handleEscKey(event: KeyboardEvent) {
  if (event.key === 'Escape') showShortcuts.value = false
}

watch(showShortcuts, (open) => {
  if (open) {
    document.addEventListener('mousedown', handleOutsideClick)
    document.addEventListener('keydown', handleEscKey)
  } else {
    document.removeEventListener('mousedown', handleOutsideClick)
    document.removeEventListener('keydown', handleEscKey)
  }
})

watch(
  () => props.showRowControls,
  (showRowControls) => {
    if (!showRowControls && showShortcuts.value) {
      showShortcuts.value = false
    }
  }
)

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleOutsideClick)
  document.removeEventListener('keydown', handleEscKey)
})

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showRowControls && _ctx.reason)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.reason), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.showRowControls)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_tooltip, {
              location: "top",
              text: _ctx.addRowReason ?? '',
              disabled: !_ctx.addRowReason
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createElementVNode("span", _normalizeProps(_guardReactiveProps(tooltipProps)), [
                  _createVNode(OutlineButton, {
                    text: "Adicionar linha",
                    width: "150px",
                    height: "36px",
                    "data-testid": "sheet-add-row-button",
                    disabled: !_ctx.canAddRow,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('addRow')))
                  }, null, 8, ["disabled"])
                ], 16)
              ]),
              _: 1
            }, 8, ["text", "disabled"]),
            _createVNode(_component_v_tooltip, {
              location: "top",
              text: _ctx.deleteRowReason ?? '',
              disabled: !_ctx.deleteRowReason
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createElementVNode("span", _normalizeProps(_guardReactiveProps(tooltipProps)), [
                  _createVNode(OutlineButton, {
                    text: "Excluir última linha",
                    width: "185px",
                    height: "36px",
                    "data-testid": "sheet-delete-row-button",
                    disabled: !_ctx.canDeleteRow,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('deleteRow')))
                  }, null, 8, ["disabled"])
                ], 16)
              ]),
              _: 1
            }, 8, ["text", "disabled"]),
            _createVNode(OutlineButton, {
              text: "Desfazer",
              width: "120px",
              height: "36px",
              "data-testid": "sheet-undo-button",
              disabled: !_ctx.canUndo,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('undo')))
            }, null, 8, ["disabled"]),
            _createElementVNode("div", {
              ref_key: "shortcutsContainerRef",
              ref: shortcutsContainerRef,
              class: "relative"
            }, [
              _createVNode(OutlineButton, {
                text: "Atalhos",
                width: "120px",
                height: "36px",
                "data-testid": "sheet-shortcuts-button",
                "aria-haspopup": "true",
                "aria-expanded": showShortcuts.value,
                "aria-controls": "sheet-shortcuts-popover",
                onClick: toggleShortcuts
              }, null, 8, ["aria-expanded"]),
              (showShortcuts.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SHEET_SHORTCUTS), (shortcut) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: shortcut.keys,
                        class: "sheet-shortcuts-popover-item"
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(shortcut.keys), 1),
                        _createTextVNode(" — " + _toDisplayString(shortcut.description), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 512)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_v_autocomplete, {
        "model-value": _ctx.selectedSheetModel,
        items: _ctx.sheetModels,
        "item-title": "label",
        "item-value": "id",
        label: "Modelo de Folha",
        variant: "outlined",
        density: "compact",
        class: "min-w-[220px]",
        "hide-details": "",
        "return-object": "",
        "data-testid": "sheet-template-select",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = (model) => emit('selectSheetModel', model as SheetModelOption))
      }, null, 8, ["model-value", "items"])
    ])
  ]))
}
}

})